import { render, staticRenderFns } from "./NoLongerStock.vue?vue&type=template&id=772fe0ef"
import script from "./NoLongerStock.vue?vue&type=script&lang=js"
export * from "./NoLongerStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports